/*
  Dip <dip-es-note> — the "Extra Sensitive, explained" pop-up that sits under any
  scent/type picker offering the Extra Sensitive laundry formula (laundry PDP, the
  dishwasher PDP's laundry add-on, and both bundle builders). Markup lives in
  snippets/dip-es-note.liquid; the dialog reuses the canonical .dip-modal chrome.
  Open/close wiring only, the same shape as the buy box's subscription modal.
*/
class DipEsNote extends HTMLElement {
  connectedCallback() {
    const link = this.querySelector('[data-es-open]');
    const modal = this.querySelector('dialog');
    if (!link || !modal) return;
    const supportsModal = typeof modal.showModal === 'function';
    const open = () => { supportsModal ? modal.showModal() : modal.setAttribute('open', ''); };
    const close = () => { supportsModal ? modal.close() : modal.removeAttribute('open'); };
    link.addEventListener('click', open);
    this.querySelector('[data-es-close]')?.addEventListener('click', close);
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
  }
}

if (!customElements.get('dip-es-note')) customElements.define('dip-es-note', DipEsNote);

export { DipEsNote };
